var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"menuOptions__position"},[_c('div',{staticClass:"menuOptions__background",style:(_vm.position)},[_vm._t("top"),_vm._t("middle"),_vm._t("end")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }